import React, { ReactNode } from 'react';
import { StrategyReferralInfo } from 'src/components/Strategy/Admin/StrategyReferralInfo';
import { PulseToggle } from 'src/components/PulseUI';
import { faList } from '@fortawesome/pro-solid-svg-icons';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons';

type View = 'map' | 'list';

interface StrategyProfileHeaderProps {
  view: View;
  setView: (value: View) => void;
  description: string;
  title: string;
  showToggle?: boolean;
  isEngageStrategy?: boolean;
  isPatientJourney?: boolean;
  children?: ReactNode;
}

const StrategyProfileHeader = ({
  view,
  setView,
  description,
  title,
  showToggle = true,
  isEngageStrategy = false,
  isPatientJourney = false,
  children,
}: StrategyProfileHeaderProps) => {
  const viewOptions = [
    { label: 'Map', value: 'map' as const, icon: faGlobe },
    { label: 'List', value: 'list' as const, icon: faList },
  ];

  return (
    <div className="self-stretch flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <StrategyReferralInfo
          showMapButton={false}
          description={description}
          title={title}
          isEngageStrategy={isEngageStrategy}
          isPatientJourney={isPatientJourney}
        />
        {showToggle && (
          <div className="flex flex-row items-center gap-2 flex-shrink-0">
            <PulseToggle
              value={view}
              options={viewOptions}
              onChange={setView}
              size="md"
              alwaysShowLabels
              className="min-w-40"
            />
          </div>
        )}
      </div>
      {children}
    </div>
  );
};

export default StrategyProfileHeader;
